// shadcn-standard `cn` helper (clsx-only; no tailwind-merge per §3.1 drop list).
import { clsx, type ClassValue } from "clsx";

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
